import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'
import type { AxiosResponse } from 'axios'
import type { FlowActionsChildEditionResponse, ChildEditionId } from '@/types'

export default {
  get(childEditionId: ChildEditionId): Promise<AxiosResponse<FlowActionsChildEditionResponse>> {
    return http.get(endpoints.get('flowActionsChildEdition', { childEditionId }))
  }
}
